export * from '../index';
import * as _operators from '../operators/index';
export var operators = _operators;
import * as _testing from '../testing/index';
export var testing = _testing;
import * as _ajax from '../ajax/index';
export var ajax = _ajax;
import * as _webSocket from '../webSocket/index';
export var webSocket = _webSocket;
//# sourceMappingURL=umd.js.map